import { Reveal } from "./motion/Reveal";

export function ChapterHeading({ index, eyebrow, title, className = "", align = "left" }) {
  return (
    <Reveal className={`${align === "center" ? "text-center" : ""} ${className}`}>
      <div
        className={`flex items-baseline gap-4 ${align === "center" ? "justify-center" : ""}`}
      >
        <span className="font-mono text-xs tracking-[0.2em] text-faint">{index}</span>
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-faint">
          {eyebrow}
        </span>
        <span aria-hidden="true" className="hidden h-px flex-1 bg-line sm:block" />
      </div>
      <h2 className="mt-6 max-w-2xl font-display text-3xl font-light leading-[1.12] tracking-tight text-ink sm:text-4xl lg:text-[2.75rem]">
        {title}
      </h2>
    </Reveal>
  );
}
